(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', 'Dashboard', 'History', 'AlertService', 'Search', 'Sector', 'CompanyStatus', 'ContactEmail', 'Picture', '$state'];

    function HomeController ($scope, Principal, LoginService, Dashboard, History, AlertService, Search, Sector, CompanyStatus, ContactEmail, Picture, $state) {
        var vm = this;
        vm.hide =false;
        vm.oldValue = "";
        vm.account = null;
        vm.isAuthenticated = null;
        vm.aboutSlideActive = 0;
        vm.conceptSlideActive = 0;
        vm.storiesSlideActive = 0;
        vm.login = LoginService.open;
        vm.news = [];
        vm.newsfeedFocus = '';
        vm.newsPage = 1;
        vm.itemsPerPage = 10;
        vm.hasNextPageNews = true;
        vm.contactEmail = {
            mail: '',
            firstName: '',
            lastName: '',
            company: '',
            position: '',
            subject: '',
            message: ''
        };
        vm.contactMessageError = false;
        vm.contactMessageSent = false;
        vm.filters = {
            eventTypes: {
                contribution: true,
                modification: true,
                add: true
            },
            types: {
                profile: true,
                company: true,
                collectivity: true
            }
        };

        vm.statsWebsite = {
            companies: {
                count: 0,
                rate: 0
            },
            collectivities: {
                count: 0,
                rate: 0
            },
            quilinkers: {
                count: 0,
                rate: 0
            },
            quilinkees : {
                count: 0,
                rate: 0
            }
        };
        vm.statsAccount = {
            position: {
                count: 5,
                rate: 0
            },
            deals: {
                count: 0,
                rate: 0
            },
            contributions: {
                count: 0,
                rate: 0
            },
            network: {
                count: 0,
                rate: 0
            },
            networkWithGrade3: {
                count: 0,
                rate: 0
            }
        };

        vm.newsfeedSearch = newsfeedSearch;
        vm.getNewsfeed = getNewsfeedSearch;
        vm.loadMoreNewsfeed = loadMoreNewsfeed;
        vm.sendContactEmail = sendContactEmail;

        init($scope);


        function init($scope) {


            $scope.homeBusyPromise = Principal.identity()
            .then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            }).then(function(result) {
                if (!Principal.isAuthenticated()){
                    //LoginService.open();
                    //$window.location.href = '/#/login';
                    //$location.path( "/login" );
                    $state.go('login', {}, {reload: true});
                } else {
                     // Get Dashboard
                    return Dashboard.get().then(function (data) {
                        // Dashboard result processing
                        vm.statsWebsite = {
                            companies: { count: data.company, rate: 0 },
                            collectivities: { count: data.collectivity, rate: -1 },
                            quilinkers: { count: data.user, rate: 3 },
                            quilinkees: { count: data.profile, rate: 3 },
                            currentMonth: data.currentMonth
                        };
                        vm.statsAccount = {
                            position: { count: 5, rate: 5 },
                            deals: { count: 0, rate: 3 },
                            contributions: { count: data.contributions, rate: -2 },
                            network: { count: data.myNetwork, rate: 2 },
                            networkWithGrade3: { count: data.myNetworkWithGrade3, rate: 2 },
                            internal: { count: data.internal, rate: 2 },
                            currentMonth: data.currentMonth
                        };
                        computeProgressBarWidth();
                    /*
                    }).then(function(result) {
                        return getNewsfeed();
                    }).then(function(data, headers) {
                        return onNewsfeedSuccess(data, headers, true);
                    }).then(function(result) {
                        getFilters();
                    */
                    }).then(function(result) {
                        vm.hide = false;
                    });
                }

            });

        }

        function sendContactEmail() {
            return ContactEmail.save(vm.contactEmail).$promise
                .then(function () {
                    vm.contactMessageError = false;
                    vm.contactMessageSent = true;
                })
                .catch(function () {
                    vm.contactMessageError = true;
                    vm.contactMessageSent = false;
                })
        }

        function getFilters() {
            Sector.query(storeSectors);
            CompanyStatus.query(storeCompanyStatuses);

            function storeSectors(sectors) {
                vm.sectors = sectors;
            }

            function storeCompanyStatuses(companyStatuses) {
                vm.companyStatuses = companyStatuses;
            }
        }

        /*
        function getAccount() {
            return Principal.identity()
            .then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            }).then(function(result) {
                getDashboard();
            });
        }
        */


        function computeProgressBarWidth() {
            /**
             * Bar width is computed using the formulae :
             *      width = 50% + 50 * value / max
             * where max is the maximum of the values in the left panel (wMax) or the right panel (aMax).
             *
             * The 'position' key has a special width formulae :
             *      width = 50% + 50 * | (20 - value) / 20 |
             * after 20th position -> with = 50%
             */

            // Website (left)
            var wKeys = ['companies', 'collectivities', 'quilinkers', 'quilinkees'];
            var wMax = 0;
            // Compute wMax
            wKeys.forEach(function (key) {
                if (vm.statsWebsite[key].count > wMax) {
                    wMax = vm.statsWebsite[key].count;
                }
            });
            if (wMax === 0) {
                wKeys.forEach(function (key) {
                    vm.statsWebsite[key].width = 50;
                });
            } else {
                wKeys.forEach(function (key) {
                    vm.statsWebsite[key].width = 50 + 50 * vm.statsWebsite[key].count / wMax;
                });
            }

            // Account (right)
            var aKeys = ['position', 'deals', 'contributions', 'network'];
            var aMax = 0;
            aKeys.forEach(function (key) {
                if (vm.statsAccount[key].count > aMax) {
                    aMax = vm.statsAccount[key].count;
                }
            });
            if (aMax === 0) {
                aKeys.forEach(function (key) {
                    vm.statsAccount[key].width = 50;
                });
            } else {
                aKeys.forEach(function (key) {
                    if (key === 'position') {
                        vm.statsAccount[key].width = 50 + 50 * Math.max((20 - vm.statsAccount[key].count) / 20, 0);
                    } else {
                        vm.statsAccount[key].width = 50 + 50 * vm.statsAccount[key].count / aMax;
                    }
                });
            }
        }

        function getNewsfeed() {
            if (!vm.newsfeedFocus.id) {
                return History.newsfeed({
                    sectorId: vm.filters.sectorId,
                    page: vm.newsPage - 1,
                    size: vm.itemsPerPage
                }).$promise;
            } else if (vm.newsfeedFocus.dropdownType === 'collectivity' || vm.newsfeedFocus.dropdownType === 'company') {
                return History.newsfeedOrganisation({
                    id: vm.newsfeedFocus.id,
                    page: vm.newsPage - 1,
                    size: vm.itemsPerPage
                }).$promise;
            } else if (vm.newsfeedFocus.dropdownType === 'profile') {
                return History.newsfeedProfile({
                    id: vm.newsfeedFocus.id,
                    page: vm.newsPage - 1,
                    size: vm.itemsPerPage
                }).$promise;
            }
        }

        function onNewsfeedSuccess(data, headers, reset) {
            var profile, organisation, previousPosition;
            data.forEach(function (event) {
                profile = event.news.profile;
                organisation = event.news.organisation;
                previousPosition = event.news.previousPosition;

                switch (event.newsType) {
                    case 'NEW_ORGANISATION':
                        event.type = 'profile';
                        event.itemId = profile.id;
                        event.name = profile.firstName + ' ' + profile.lastName;


                        event.message = 'a modifié son entreprise :';

                        event.title = profile.currentPosition.title;
                        event.organisation = organisation.name;
                        event.organisationId = organisation.id;
                        event.previousOrganisation = previousPosition && previousPosition.organisation && (previousPosition.organisation.name != organisation.name) ? previousPosition.organisation.name : null;
                        event.previousOrganisationId = previousPosition && previousPosition.organisation ? previousPosition.organisation.id : null;
                        loadProfilePicture(profile, event);
                        event.date = new Date(event.info.revtstmp);
                        break;
                    case 'NEW_TITLE':
                        event.type = 'profile';
                        event.itemId = profile.id;
                        event.name = profile.firstName + ' ' + profile.lastName;

                        event.message = 'a modifié son poste :';

                        event.title = profile.currentPosition.title;
                        event.previousTitle = previousPosition && (previousPosition.title != profile.currentPosition.title) ? previousPosition.title : null;

                        event.organisation = organisation.name;
                        event.organisationId = organisation.id;
                        event.previousOrganisation = previousPosition && previousPosition.organisation && (previousPosition.organisation.name != organisation.name) ? previousPosition.organisation.name : null;
                        event.previousOrganisationId = previousPosition && previousPosition.organisation ? previousPosition.organisation.id : null;

                        loadProfilePicture(profile, event);
                        event.date = new Date(event.info.revtstmp);
                        break;
                    case 'NEW_MEMBER':
                        event.type = organisation.type;
                        event.itemId = organisation.id;
                        event.name = organisation.name;

                        event.subItemId = organisation ? organisation.id : null;
                        event.subName = organisation ? organisation.name : null;


                        event.message = 'a un nouveau collaborateur';
                        event.member = profile.firstName + ' ' + profile.lastName;

                        event.picture = organisation.logoContentType ?
                            'data:' + organisation.logoContentType + ';base64,' + organisation.logo
                            : 'content/images/no-picture-company.png';
                        event.date = new Date(event.info.revtstmp);
                        break;
                    case 'POSITION_CHANGE':
                        event.type = 'profile';
                        event.itemId = profile.id;
                        event.name = profile.firstName + ' ' + profile.lastName;

                        event.message = 'a modifié son profil :';

                        event.title = profile.currentPosition.title;
                        event.organisation = organisation.name;
                        event.organisationId = organisation.id;

                        event.previousOrganisation = previousPosition && previousPosition.organisation && (previousPosition.organisation.name != organisation.name) ? previousPosition.organisation.name : null;
                        event.previousOrganisationId = previousPosition && previousPosition.organisation ? previousPosition.organisation.id : null;

                        event.picture = organisation.logoContentType ?
                            'data:' + organisation.logoContentType + ';base64,' + organisation.logo
                            : 'content/images/no-picture-company.png';
                        event.date = new Date(event.info.revtstmp);
                        break;

                }

            });
            //vm.hasNextPageNews = headers('X-Has-Next-Page') === "true";
            console.log("loadMoreNewsfeed", vm.newsPage, vm.hasNextPageNews);
            vm.news = reset ? data : vm.news.concat(data);
        }


        function getNewsfeedSearch() {
            vm.newsPage = 1;
            console.log("loadMoreNewsfeed", vm.newsPage, vm.hasNextPageNews);
            getNewsfeed().then(function(data, headers) {
                return onNewsfeedSuccess(data, headers, true);
            })

        }
        function loadMoreNewsfeed() {
            vm.newsPage += 1;
            console.log("loadMoreNewsfeed", vm.newsPage, vm.hasNextPageNews);
            getNewsfeed().then(function(data, headers) {
                return onNewsfeedSuccess(data, headers, false);
            })

        }

        function newsfeedSearch(q) {
            if (q == "" && vm.oldValue!="") {
                vm.newsfeedFocus = '';
                vm.oldValue = "";
                getNewsfeedSearch();
            } else if (q!=""){
                 vm.oldValue = q;
                return Search.query(q).then(reshapeQueryResults);
            }
        }

        function reshapeQueryResults(response) {
            var data = response.data;
            var collectivities = data.collectivities.map(function (el) {
                el.dropdownType = 'collectivity';
                return el;
            });
            var companies = data.companies.map(function (el) {
                el.dropdownType = 'company';
                return el;
            });
            var profiles1 = data.profiles['1'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles2 = data.profiles['2'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles3 = data.profiles['3'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            /*
            var res = companies.splice(0, 2)
                .concat(collectivities.splice(0, 2))
                .concat(profiles1.splice(0, 3))
                .concat(profiles2.splice(0, 2))
                .concat(profiles3.splice(0, 2));
            */
             var res = companies
                .concat(collectivities)
                .concat(profiles1)
                .concat(profiles2)
                .concat(profiles3);
            return res;
        }

        function onFetchError(error) {
            AlertService.error(error.data.message);
        }

        function loadProfilePicture(profile, event){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    event.picture = 'data:' + profile.pictureContentType + ';base64,' + response;
                }, function (response) {
                    event.picture =  'content/images/no-picture.png';
                });
            } else {
                event.picture =  'content/images/no-picture.png';
            }
        }
    }
})();
